<template>
  <div class="about-container info-html-wrapper">
    <h1 class="title">
      {{ $t('details.terms-of-use') }}
    </h1>
    <html-loader :url="contentUrl" />
  </div>
</template>

<script>
import DefaultContentPage from './ContentPage/DefaultContentPage';

export default {
  extends: DefaultContentPage,
  data() {
    return {
      pageHandle: 'terms-of-use',
    };
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/TermsOfUse.vue